import { CLASSIC_VARIANT, patientControlPoints } from "../shared/controleVariants";

export const VARIANT = CLASSIC_VARIANT;

export const SECTIONS = VARIANT.sections;

export const PATIENT_CONTROL_POINTS = patientControlPoints(VARIANT);

export const PATIENT_CONTROL_POINT_TOTAL = PATIENT_CONTROL_POINTS.length;

export const PATIENT_CONTROL_INSTRUCTIONS = VARIANT.patientControlInstructions;
